import React from "react";
import { History } from "history";
import moment from "moment";
import { Page } from "../..";
import { Box, Alerta, TipoAlerta, Row, Col, Botao, TipoBotao, CampoEstatico, TipoCampoEstatico } from "@intechprev/componentes-web";
import {
  PlanoVinculadoEntidade,
  NaturezaEmprestimoEntidade,
  ContratoEmprestimoEntidade,
} from "../../../entidades";
import { IParametrosSimulacao } from ".";
import { ContratoEmprestimoService } from "../../../services";
import { timeStamp } from "console";

interface Props {
  history?: History;
}

interface State {
  dadosSimulacao: IParametrosSimulacao;

  dadosParcelas: any;

  tabela: string;
  prestacao: any;
}

export class EmprestimosSimuladorPrestacoes extends React.Component<
  Props,
  State
> {
  private page = React.createRef<Page>();
  private alert = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    const dados: IParametrosSimulacao = JSON.parse(
      localStorage.getItem("emprestimo-parametros")
    );

    this.state = {
      dadosSimulacao: dados,
      dadosParcelas: null,

      tabela: "",
      prestacao: {
        Prazo: 0
      }
    };
  }

  componentDidMount = async () => {
    await this.page.current.loading(true);

    const parametros = {
      SqNatureza: this.state.dadosSimulacao.natureza.SQ_NATUREZA,
      SqPlanoPrevidencial: this.state.dadosSimulacao.plano.SQ_PLANO_PREVIDENCIAL,
      ValorSolicitado: this.state.dadosSimulacao.valorSolicitado,
    };

    var dadosParcelas = await ContratoEmprestimoService.BuscarParcelas(
      parametros
    );
    await this.setState({
      dadosParcelas: dadosParcelas.Resultado,
    });

    await this.page.current.loading(false);
  };

  carregarDados = async () => { };

  continuar = async () => {
    await this.alert.current.limparErros();

    if (this.state.tabela === "") {
      await this.alert.current.adicionarErro(
        "<b>Atenção:</b> Selecione uma prestação acima."
      );
    }

    if (
      this.alert.current.state.mensagem.length === 0 &&
      this.alert.current.props.mensagem.length === 0
    ) {
      var dados: IParametrosSimulacao = {
        ...this.state.dadosSimulacao,
        prestacao: this.state.prestacao,
        tabela: this.state.tabela,
        valorCorrecao: this.state.dadosParcelas.ValorCorrecao,
        valorJurosAdicional: this.state.dadosParcelas.ValorJurosAdicional
      };

      await localStorage.setItem(
        "emprestimo-parametros",
        JSON.stringify(dados)
      );
      this.props.history.push("/emprestimosSimuladorResumo");
    }
  };

  render() {
    return (
      <Page {...this.props} ref={this.page}>
        {this.page.current && (
          <>
            <h3>Bem-Vindo ao Simulador de Empréstimos da EQTPREV!</h3>
            <h5>
              Ao final da sua simulação você poderá realizar o requerimento do
              seu empréstimo diretamente por aqui, de forma on-line e segura!
            </h5>

            {this.state.dadosParcelas.mensagem && <Alerta
              mensagem={this.state.dadosParcelas.mensagem}
              tipo={TipoAlerta.danger}
              tamanho={"6"}
            />}

            {this.state.dadosParcelas.Price &&
              <Box titulo={"Prazos e Prestações"}>
                <p>
                  Selecione o melhor prazo disponível para você!
                </p>

                <Alerta
                  tipo={TipoAlerta.info}
                  mensagem="Pela Tabela Price, as parcelas mensais são fixas. Neste sistema, a maior parte da primeira prestação é formada por juros."
                />

                <Row>
                  <Col>
                    <b>Prestações pela Tabela PRICE</b>
                    <table className="table table-sm table-hover">
                      <thead>
                        <tr>
                          <th></th>
                          <th className="text-center">Prazo</th>
                          <th className="text-right">Taxa</th>
                          <th className="text-right">Prestação Inicial Prevista</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.dadosParcelas.Price.map(
                          (prestacao: any, index: number) => {
                            return (
                              <tr
                                key={index}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (prestacao.Prazo === this.state.prestacao.Prazo)
                                    this.setState({ tabela: "", prestacao: { Prazo: 0 } });
                                  else
                                    this.setState({
                                      prestacao,
                                      tabela: "PRICE"
                                    });
                                }}
                              >
                                <td>
                                  {this.state.tabela === "PRICE" && this.state.prestacao === prestacao && (
                                    <div>
                                      <i className="fas fa-check-circle text-success"></i>
                                    </div>
                                  )}
                                  {this.state.prestacao !== prestacao && (
                                    <div>
                                      <i className="far fa-circle text-primary"></i>
                                    </div>
                                  )}
                                </td>
                                <td className="text-center">{prestacao.Prazo}</td>
                                <td className="text-right">{prestacao.Taxa.toFixed(6).replace('.', ',')}</td>
                                <td className="text-right">
                                  <CampoEstatico
                                    valor={prestacao.Valor}
                                    tipo={TipoCampoEstatico.dinheiro}
                                  />
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </Col>
                </Row>

                <Alerta
                  ref={this.alert}
                  padraoFormulario
                  tipo={TipoAlerta.danger}
                  tamanho={"6"}
                />
                <Botao
                  titulo={"Resumo da Simulação"}
                  onClick={this.continuar}
                  submit
                /><br />

                <Botao
                  titulo={"Voltar"}
                  onClick={() => this.props.history.goBack()}
                  tipo={TipoBotao.light}
                  className='mt-3'
                />
              </Box>
            }
          </>
        )}
      </Page>
    );
  }
}
